"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.testHooks = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _ZillowMapContext = _interopRequireDefault(require("./ZillowMapContext"));

var _jsxFileName = "/builds/zillow/searchxp/zillow-map-control/src/TransportationLayer.jsx";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var VALID_LAYER_TYPES = ['TransitLayer', 'TrafficLayer', 'BicyclingLayer'];

var TransportationLayer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TransportationLayer, _Component);

  function TransportationLayer(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _reactAutobind.default)(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = TransportationLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var canUseDOM = typeof window !== 'undefined';
    var shouldInitializeTransportationLayer = canUseDOM && !(0, _isEmpty2.default)(window.google) && VALID_LAYER_TYPES.includes(this.props.layerType);

    if (shouldInitializeTransportationLayer) {
      this.initializeTransportationLayer();
    }
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  _proto.initializeTransportationLayer = function initializeTransportationLayer() {
    var transportLayer = new google.maps[this.props.layerType]();
    transportLayer.setMap(this.props.gmap);
  };

  _proto.render = function render() {
    return null;
  };

  return TransportationLayer;
}(_react.Component);

;

var mapContextToProps = function mapContextToProps(props) {
  return _react.default.createElement(_ZillowMapContext.default.Consumer, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }, function (contextData) {
    if (contextData.gmap) {
      return _react.default.createElement(TransportationLayer, _extends({}, props, contextData, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 46
        },
        __self: this
      }));
    }

    return null;
  });
};

TransportationLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  gmap: _propTypes.default.shape({}).isRequired,
  layerType: _propTypes.default.oneOf(VALID_LAYER_TYPES).isRequired
} : {};
var testHooks = {
  TransportationLayer: TransportationLayer
};
exports.testHooks = testHooks;
var _default = mapContextToProps;
exports.default = _default;